const LandingPageDesign = () => import('@/views/landing-page-design/landing-page-design-view');
const LandingPageDetails = () => import('@/views/landing-page/landing-page-details-view.vue');
const LandingPageDomains = () => import('@/views/landing-page/landing-page-domains');
const LandingPageFooterBuilder = () => import('@/views/landing-page/landing-page-footer-builder-view.vue');
const LandingPageHeaderDesigner = () => import('@/views/landing-page/landing-page-header-design-view.vue');
const LandingPageHeaders = () => import('@/views/landing-page/headers/landing-page-headers-index-view');
const LandingPageFooters = () => import('@/views/landing-page/footers/landing-page-footers-index-view');
const LandingPageTemplates = () => import('@/views/landing-page/template/landing-page-templates-index');
const LandingPages = () => import('@/views/landing-page/landing-page-index-view.vue');
const LandingPageForms = () => import('@/views/landing-page/landing-page-forms/landing-page-forms-index');
const LandingPageFormSubmissions = () => import('@/views/landing-page/landing-page-form-submissions-view');
const LandingPageFormOverview = () => import('@/views/landing-page/landing-page-form-overview-view');
const LandingPageFormDesign = () => import('@/views/landing-page/landing-page-form-design-view');

export default [
    {
        path: '/LandingPages/',
        name: 'LandingPagesIndex',
        component: LandingPages,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-index-page',
            pageTitle: 'Landing Pages',
        },
    },
    {
        path: '/LandingPages/:landingPageId/Details',
        name: 'LandingPageDetails',
        component: LandingPageDetails,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-details-page',
            pageTitle: 'Landing Page Details',
        },
    },
    {
        path: '/LandingPages/:landingPageId/Design',
        name: 'LandingPageDesign',
        component: LandingPageDesign,
        meta: {
            subtype: 'landingPage',
            isUiShown: false,
            pageClass: 'landing-page-design-page',
            pageTitle: 'Landing Page Builder',
        },
    },
    {
        path: '/LandingPages/Headers',
        name: 'LandingPageHeaders',
        component: LandingPageHeaders,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'headers-page',
            pageTitle: 'Headers',
        },
    },
    {
        path: '/LandingPages/Footers',
        name: 'LandingPageFooters',
        component: LandingPageFooters,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'footer-page',
            pageTitle: 'Footers',
        },
    },
    {
        path: '/LandingPages/Headers/:id',
        name: 'LandingPageHeaderDesigner',
        component: LandingPageHeaderDesigner,
        meta: {
            type: 'client',
            subtype: 'landing-page',
            isUiShown: false,
            pageClass: 'landing-page-designer-page',
            pageTitle: 'Header Builder',
        },
    },
    {
        path: '/LandingPages/Footers/:id',
        name: 'LandingPageFooterBuilder',
        component: LandingPageFooterBuilder,
        meta: {
            type: 'client',
            subtype: 'landing-page',
            isUiShown: false,
            pageClass: 'landing-page-designer-page',
            pageTitle: 'Footer Builder',
        },
    },
    {
        path: '/LandingPages/Templates',
        name: 'LandingPageTemplates',
        component: LandingPageTemplates,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-templates-page',
            pageTitle: 'Landing Page Templates',
        },
    },
    {
        path: '/LandingPages/Templates/:landingPageTemplateId/Design',
        name: 'LandingPageTemplateDesign',
        component: LandingPageDesign,
        meta: {
            subtype: 'landingPage',
            isUiShown: false,
            pageClass: 'landing-page-template-design-page',
            pageTitle: 'Landing Page Template Builder',
        },
    },
    {
        path: '/LandingPages/Domains',
        name: 'LandingPageDomains',
        component: LandingPageDomains,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageTitle: 'Landing Pages Domains',
        },
    },
    {
        path: '/LandingPages/Forms',
        name: 'LandingPageForms',
        component: LandingPageForms,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageTitle: 'Landing Page Forms'
        },
    },
    {
        path: '/LandingPages/Forms/:formId/Submissions',
        name: 'LandingPageFormSubmissions',
        component: LandingPageFormSubmissions,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-form-submissions-page',
            pageTitle: 'Landing Page Form Submissions'
        }
    },
    {
        path: '/LandingPages/:landingPageId/Forms/Submissions',
        name: 'LandingPageFormSubmissionsByLP',
        component: LandingPageFormSubmissions,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-form-submissions-page',
            pageTitle: 'Landing Page Form Submissions'
        }
    },
    {
        path: '/LandingPages/Forms/:formId/Overview',
        name: 'LandingPageFormOverview',
        component: LandingPageFormOverview,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-form-overview',
            pageTitle: 'Landing Page Form Overview'
        }
    },
    {
        path: '/LandingPages/Forms/:formId/Design',
        name: 'LandingPageFormBuilder',
        component: LandingPageFormDesign,
        meta: {
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'landing-page-form-design-page',
            pageTitle: 'Landing Page Form Builder'
        }
    },

    // Clients

    {
        path: '/Clients/:clientId/LandingPages',
        name: 'ClientsLandingPages',
        component: LandingPages,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-index-page',
            pageTitle: 'Landing Pages'
        }
    },
    {
        path: '/Clients/:clientId/LandingPages/Headers',
        name: 'ClientLandingPageHeaders',
        component: LandingPageHeaders,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'headers-page',
            pageTitle: 'Headers',
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/Footers',
        name: 'ClientLandingPageFooters',
        component: LandingPageFooters,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'footers-page',
            pageTitle: 'Footers',
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/Domains',
        name: 'ClientLandingPageDomains',
        component: LandingPageDomains,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageTitle: 'Landing Pages Domains',
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/Headers/:id',
        name: 'ClientLandingPageHeaderDesigner',
        component: LandingPageHeaderDesigner,
        meta: {
            type: 'client',
            subtype: 'landing-page',
            isUiShown: false,
            pageClass: 'landing-page-designer-page',
            pageTitle: 'Header Builder',
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/Footers/:id',
        name: 'ClientLandingPageFooterBuilder',
        component: LandingPageFooterBuilder,
        meta: {
            type: 'client',
            subtype: 'landing-page',
            isUiShown: false,
            pageClass: 'landing-page-designer-page',
            pageTitle: 'Footer Builder',
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/:landingPageId/Design',
        name: 'ClientLandingPageDesign',
        component: LandingPageDesign,
        meta: {
            type: 'client',
            subtype: 'landingPage',
            isUiShown: false,
            pageClass: 'landing-page-design-page',
            pageTitle: 'Landing Page Builder',
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/:landingPageId/Details',
        name: 'ClientLandingPageDetails',
        component: LandingPageDetails,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-details-page',
            pageTitle: 'Landing Page Details',
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/Templates',
        name: 'ClientLandingPageTemplates',
        component: LandingPageTemplates,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-templates-page',
            pageTitle: 'Landing Page Templates',
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/Templates/:landingPageTemplateId/Design',
        name: 'ClientLandingPageTemplateDesign',
        component: LandingPageDesign,
        meta: {
            type: 'client',
            subtype: 'landingPage',
            isUiShown: false,
            pageClass: 'landing-page-template-design-page',
            pageTitle: 'Landing Page Template Builder',
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/Forms',
        name: 'ClientLandingPageForms',
        component: LandingPageForms,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageTitle: 'Landing Page Forms'
        },
    },
    {
        path: '/Clients/:clientId/LandingPages/Forms/:formId/Submissions',
        name: 'ClientLandingPageFormSubmissions',
        component: LandingPageFormSubmissions,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-form-submissions-page',
            pageTitle: 'Landing Page Form Submissions'
        }
    },
    {
        path: '/Clients/:clientId/LandingPages/:landingPageId/Forms/Submissions',
        name: 'ClientLandingPageFormSubmissionsByLP',
        component: LandingPageFormSubmissions,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-form-submissions-page',
            pageTitle: 'Landing Page Form Submissions'
        }
    },
    {
        path: '/Clients/:clientId/LandingPages/Forms/:formId/Overview',
        name: 'ClientLandingPageFormOverview',
        component: LandingPageFormOverview,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-form-overview',
            pageTitle: 'Landing Page Form Overview'
        }
    },
    {
        path: '/Clients/:clientId/LandingPages/Forms/:formId/Design',
        name: 'ClientLandingPageFormBuilder',
        component: LandingPageFormDesign,
        meta: {
            type: 'client',
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'landing-page-form-design-page',
            pageTitle: 'Landing Page Form Builder'
        }
    },

    // Agencies

    {
        path: '/Agencies/:agencyId/LandingPages/Templates',
        name: 'AgencyLandingPageTemplates',
        component: LandingPageTemplates,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'landing-page-templates-page',
            pageTitle: 'Landing Page Templates',
        },
    },
    {
        path: '/Agencies/:agencyId/LandingPages/Templates/:landingPageTemplateId/Design',
        name: 'AgencyLandingPageTemplateDesign',
        component: LandingPageDesign,
        meta: {
            subtype: 'landingPage',
            isUiShown: false,
            pageClass: 'landing-page-template-design-page',
            pageTitle: 'Landing Page Template Builder',
        },
    },
    {
        path: '/Agencies/:agencyId/LandingPages/Forms',
        name: 'AgencyLandingPageForms',
        component: LandingPageForms,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageTitle: 'Landing Page Forms'
        },
    },
    {
        path: '/Agencies/:agencyId/LandingPages/Forms/:formId/Design',
        name: 'AgencyLandingPageFormBuilder',
        component: LandingPageFormDesign,
        meta: {
            subtype: 'marketing',
            isUiShown: false,
            pageClass: 'landing-page-form-design-page',
            pageTitle: 'Landing Page Form Builder'
        }
    },
    {
        path: '/Agencies/:agencyId/LandingPages/Headers',
        name: 'AgencyLandingPageHeaders',
        component: LandingPageHeaders,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'headers-page',
            pageTitle: 'Headers',
        },
    },
    {
        path: '/Agencies/:agencyId/LandingPages/Headers/:id',
        name: 'AgencyLandingPageHeaderDesigner',
        component: LandingPageHeaderDesigner,
        meta: {
            type: 'landing-page',
            subtype: 'landing-page',
            isUiShown: false,
            pageClass: 'landing-page-designer-page',
            pageTitle: 'Header Builder',
        },
    },
    {
        path: '/Agencies/:agencyId/LandingPages/Footers',
        name: 'AgencyLandingPageFooters',
        component: LandingPageFooters,
        meta: {
            subtype: 'marketing',
            isUiShown: true,
            pageClass: 'footers-page',
            pageTitle: 'Footers',
        },
    },
    {
        path: '/Agencies/:agencyId/LandingPages/Footers/:id',
        name: 'AgencyLandingPageFooterBuilder',
        component: LandingPageFooterBuilder,
        meta: {
            type: 'client',
            subtype: 'landing-page',
            isUiShown: false,
            pageClass: 'landing-page-designer-page',
            pageTitle: 'Footer Builder',
        },
    },
];
